import React from 'react';
import 'react-dates/lib/css/_datepicker.css';
import Form from 'src/components/form/Form';
import { Button, Checkbox, Modal } from 'semantic-ui-react';
import Swal from 'sweetalert2';
import { habeasData } from 'src/components/helpers/habeasData';
import { RegistrationForm } from 'src/assets/styles/components/Registration';
import {
  getNewMemberActivityName,
  hasMixedGroupOption,
} from 'src/containers/adminDashboard/utils/groupsTranslationMap';
import { shouldLockGuestIdentity } from 'src/components/helpers/guests/guestIdentity';

const LAW_1581_URL = 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=49981';

const CATEGORY_ERROR =
  'No pudimos determinar tu categoría de grupo. Verifica género, fecha de nacimiento y estado civil.';

export const seminaryInfo = (activityName, summary = false) => {
  if (!activityName) return null;

  return (
    <div style={{ margin: '10px 0' }}>
      <p>
        <strong>Inicio:</strong> en la semana del 17 de agosto de acuerdo al día del grupo
        seleccionado.
      </p>
      {activityName.includes('Para_Siempre') && (
        <p>
          {!summary && (
            <p>
              Pueden elegir el grupo de acuerdo a sus agendas (Día, Hora). Selecciona el grupo al
              cuál desean asistir.
            </p>
          )}
          La pareja facilitadora del seminario los estará contactando para informarles del día de
          inicio, pero si tienes alguna inquietud puedes comunicarte al
          <a
            href="https://api.whatsapp.com/send?phone=573011147734"
            target="_blank"
            rel="noreferrer"
          >
            Whatsapp 3011147734
          </a>
          .
        </p>
      )}
      {activityName.includes('Transformacion_Empresarial') && (
        <p>
          {!summary && (
            <p>
              Puedes elegir el grupo de acuerdo a tu necesidad de agenda (Día, Hora). Selecciona el
              grupo al cuál deseas asistir.{' '}
            </p>
          )}
          El facilitador del seminario se estará contactando para más información; pero si tienes
          alguna inquietud puedes comunicarte al{' '}
          <a
            href="https://api.whatsapp.com/send?phone=573011147734"
            target="_blank"
            rel="noreferrer"
          >
            Whatsapp 3011147734
          </a>
          .
        </p>
      )}
    </div>
  );
};

const CoupleGroupRegistration = (props) => {
  const { inputs, setInputs, setStep, person, next, strictNext, leaderView, loading } = props;
  const [errorInputs, set_errorInputs] = React.useState({});
  const [habeasModalOpen, setHabeasModalOpen] = React.useState(false);

  const isCrecer = window.location.pathname.includes('crecer');
  const civilStatus = (who = person) =>
    inputs?.[who]?.civil || (who === 'person1' ? inputs.civil : '') || '';

  const verifyForm = () => {
    let mandatoryInputs = ['name', 'lastName', 'identification', 'phone'];

    let inputsWithErrors = {};

    if (inputs?.[person]?.['identification'] && inputs?.[person]?.['identification'].length <= 5) {
      inputsWithErrors = {
        ...inputsWithErrors,
        identification: !inputs?.[person]?.['identification'].length >= 5,
      };
    }

    if (inputs?.[person]?.['phone'] && inputs?.[person]?.['phone'].length <= 10) {
      inputsWithErrors = {
        ...inputsWithErrors,
        phone: !inputs?.[person]?.['phone'].length === 10,
      };
    }

    if (!leaderView && !isCrecer && person === 'person1') {
      inputsWithErrors = {
        ...inputsWithErrors,
        civil: !(inputs?.[person]?.civil || inputs?.civil),
        gender: !inputs?.[person]?.gender,
        birthdate: !inputs?.[person]?.birthdate,
      };
    }

    if (!leaderView) {
      inputsWithErrors = {
        ...inputsWithErrors,
        habeasDataAccepted: !inputs?.[person]?.habeasDataAccepted,
      };
    }

    mandatoryInputs.forEach((input) => {
      inputsWithErrors = {
        ...inputsWithErrors,
        [input]: !inputs?.[person]?.[input],
      };
    });

    set_errorInputs(inputsWithErrors);
    return Object.values(inputsWithErrors).includes(true);
  };

  React.useEffect(() => {
    if (person === 'person1')
      setInputs({
        ...inputs,
        [person]: {
          ...(inputs?.[person] || {}),
          identification: inputs.identification,
          phone: inputs.phone,
          ...(inputs.civil ? { civil: inputs.civil } : {}),
        },
      });
  }, []);

  const resolveActivityName = (preferMixed = false) =>
    getNewMemberActivityName({
      gender: inputs.person1?.gender,
      birthdate: inputs.person1?.birthdate,
      civil: civilStatus('person1'),
      preferMixed,
    });

  const nextStep = (e) => {
    e.preventDefault();
    if (verifyForm()) return;
    if (
      person === 'person2' &&
      inputs?.person1?.identification === inputs?.person2?.identification
    ) {
      return Swal.fire('No puedes registrar a la misma persona como pareja');
    }
    if (person === 'person2' && inputs?.person1?.gender === inputs?.person2?.gender) {
      return Swal.fire('La pareja no puede tener el mismo genero');
    }

    if (isCrecer) {
      if (
        (!(inputs.activityName?.includes('Parejas') || inputs.activityName === 'Para_Siempre._') ||
          civilStatus('person1') === 'Soltero') &&
        !strictNext
      ) {
        setStep('selectLeaders');
      } else {
        setStep(next);
      }
      return;
    }

    if (person === 'person1') {
      // Group creation / leader flows already chose kind + category; do not overwrite them.
      if (strictNext || leaderView) {
        const selectedKind = inputs.kindgroup || inputs.kind;
        if (selectedKind) {
          setInputs({
            ...inputs,
            kind: selectedKind,
            kindgroup: selectedKind,
          });
        }
        return setStep(next);
      }

      const activityName = resolveActivityName(false);
      if (!activityName) {
        return Swal.fire(CATEGORY_ERROR);
      }

      if (
        hasMixedGroupOption({
          gender: inputs.person1?.gender,
          birthdate: inputs.person1?.birthdate,
          civil: civilStatus('person1'),
        })
      ) {
        return setStep('groupPreference');
      }

      const needsPerson2 = activityName.includes('Parejas') && civilStatus('person1') !== 'Soltero';

      setInputs({
        ...inputs,
        activityName,
        kind: 'Grupo_Discipulado',
        kindgroup: 'Grupo_Discipulado',
        preferMixed: false,
      });

      if (needsPerson2) return setStep(next);
      return setStep('selectLeaders');
    }

    if (person === 'person2') {
      if (!strictNext) return setStep('selectLeaders');
      return setStep(next);
    }

    if (!strictNext) setStep('selectLeaders');
    else setStep(next);
  };

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setInputs({
      ...inputs,
      [person]: { ...(inputs?.[person] || {}), [name]: value },
      ...(name === 'civil' && person === 'person1' ? { civil: value } : {}),
    });
  };

  const toggleHabeas = () => {
    const next = !inputs?.[person]?.habeasDataAccepted;
    setInputs({
      ...inputs,
      [person]: { ...(inputs?.[person] || {}), habeasDataAccepted: next },
    });
    set_errorInputs((prev) => ({ ...prev, habeasDataAccepted: false }));
  };

  const moreInfo = () => {
    if (!leaderView) {
      return (
        <div>
          <div className={`legal ${errorInputs.habeasDataAccepted ? 'error' : ''}`}>
            <div className="legal-header">
              <Checkbox
                checked={Boolean(inputs?.[person]?.habeasDataAccepted)}
                onChange={toggleHabeas}
                label="Autorización de tratamiento de datos personales*"
              />
            </div>
            <p className="legal-text">
              Al hacer clic en continuar, aceptas nuestra{' '}
              <a
                href="#politica-tratamiento-datos"
                onClick={(e) => {
                  e.preventDefault();
                  setHabeasModalOpen(true);
                }}
              >
                Política de Tratamiento de Datos Personales
              </a>{' '}
              de acuerdo con la{' '}
              <a href={LAW_1581_URL} target="_blank" rel="noreferrer">
                Ley 1581 de 2012
              </a>
              .
            </p>
          </div>

          <Modal
            open={habeasModalOpen}
            onClose={() => setHabeasModalOpen(false)}
            size="small"
            closeIcon
          >
            <Modal.Header>Política de Tratamiento de Datos Personales</Modal.Header>
            <Modal.Content scrolling>{habeasData}</Modal.Content>
            <Modal.Actions>
              <Button primary type="button" onClick={() => setHabeasModalOpen(false)}>
                Entendido
              </Button>
            </Modal.Actions>
          </Modal>
        </div>
      );
    }
    return <></>;
  };

  return (
    <RegistrationForm onSubmit={(e) => nextStep(e)}>
      {(inputs.kind === 'Grupo_Seminario' || inputs.kindgroup === 'Grupo_Seminario') &&
        seminaryInfo(inputs.activityName)}
      {person === 'person1' ? (
        <h2 style={{ margin: '25px 0 10px 0' }}>Llena {leaderView ? 'los' : 'tus'} datos</h2>
      ) : (
        <h2>Llena los datos de {leaderView ? 'la' : 'tu'} pareja</h2>
      )}
      {Object.values(errorInputs).includes(true) &&
        !shouldLockGuestIdentity(inputs?.[person] || {}) && (
          <h4 style={{ color: 'red' }}>Por favor verifica los campos en rojo.</h4>
        )}
      <Form
        saveTag={'Continuar '}
        Attendant={inputs?.[person] || {}}
        userprofile={true}
        handleInputs={handleInputs}
        errorInputs={errorInputs}
        sendInForm={!!next}
        loadedData={loading}
        showEmail={false}
        showBirthdate
        showGender
        showCivil
        submit={(e) => nextStep(e)}
        moreInfo={moreInfo}
        setAttendant={(updater) => {
          setInputs((prev) => ({
            ...prev,
            [person]: {
              ...(prev?.[person] || {}),
              ...(typeof updater === 'function' ? updater(prev?.[person] || {}) : updater),
            },
          }));
        }}
        setErrorInputs={set_errorInputs}
        onGuestUpdated={props.onGuestUpdated}
      />
    </RegistrationForm>
  );
};

CoupleGroupRegistration.defaultProps = {
  moreInfo: () => <div></div>,
  loading: false,
};

export default CoupleGroupRegistration;
